import type { FinanceEntrySummary } from '@aeris/contracts'

/**
 * Como o financeiro se lê em português — F154.
 *
 * Estava dentro de `routes/financeiro.tsx`, e saiu de lá quando a ficha do
 * título (F154) passou a precisar das mesmas palavras. Duas cópias de
 * "Quitado" divergiriam no primeiro dia em que alguém preferisse "Pago".
 */

export const STATUS_LABELS: Readonly<
  Record<FinanceEntrySummary['status'], string>
> = {
  open: 'Em aberto',
  settled: 'Quitado',
  cancelled: 'Cancelado',
}

/**
 * De onde o título veio: a resposta para "por que ele deve isso", que muda a
 * conversa com quem deve. Mora em `@aeris/status-meta` desde que o celular
 * passou a usar as mesmas palavras (F310).
 */
export { FINANCE_ORIGIN_LABELS as ORIGIN_LABELS } from '@aeris/status-meta'
